/* ============================================================
   BEAT PACKS - Shopify Theme JS
   Cart API - Audio - Waveform - Animations
   ============================================================ */
(function () {
  "use strict";

  const I = {
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 4h2l2.4 12.3a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.2L21 8H6"/><circle cx="9" cy="20" r="1.2" fill="currentColor" stroke="none"/><circle cx="18" cy="20" r="1.2" fill="currentColor" stroke="none"/></svg>',
    play: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg>',
    pause: '<svg viewBox="0 0 24 24" fill="currentColor"><rect x="6.5" y="5.5" width="3.6" height="13" rx="1"/><rect x="13.9" y="5.5" width="3.6" height="13" rx="1"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M4 12.5l5 5L20 6"/></svg>',
  };
  window.BPICONS = I;

  // Maps each Standard-tier pack variant -> its specific Pro License Upgrade variant.
  // Add entries here as new packs get upgrade products created.
  const BUMP_MAP = new Map([
    [44406207414496, 53035288363232],  // Icon Vol. 1 -> Pro License Upgrade - Icon Vol. 1
    [44132829429984, 53035288297696],  // Rags 2 Riches Vol. 1 -> Pro License Upgrade - Rags 2 Riches Vol. 1
    [44142397489376, 53035288232160],  // Blessed Vol. 1 -> Pro License Upgrade - Blessed Vol. 1
    [44802981920992, 53035288264928],  // Hit Maker Vol. 1 -> Pro License Upgrade - Hit Maker Vol. 1
    [53025891811552, 53035288330464],  // Dirt Roads & 808s Vol. 1 -> Pro License Upgrade - Dirt Roads & 808s Vol. 1
    [50109239394528, 53035288396000],  // Session Ready Vol. 1 -> Pro License Upgrade - Session Ready Vol. 1
    // Soul Vibes Vol. 1, Roses Vol. 1, Session Ready Vol. 2 - add entries when upgrade products are created
  ]);

  function fmtMoney(cents) { return "$" + Math.round(cents / 100); }

  async function cartPost(path, body) {
    const res = await fetch(path, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) });
    return res.json();
  }

  async function cartGet() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return res.json();
  }

  async function addToCart(variantId, productTitle) {
    variantId = parseInt(variantId, 10);
    const addBtn = document.querySelector(`[data-add-variant="${variantId}"]`);
    if (addBtn) { addBtn.disabled = true; addBtn.textContent = "Adding..."; }
    try {
      await cartPost("/cart/add.js", { items: [{ id: variantId, quantity: 1 }] });
      await refreshCart();
      openCart();
      toast((productTitle || "Pack") + " added to cart");
    } catch (e) {
      toast("Error - please try again");
    } finally {
      if (addBtn) { addBtn.disabled = false; }
    }
  }
  window.BPCart = { add: addToCart };

  async function refreshCart() {
    const cart = await cartGet();
    renderCartDrawer(cart);
  }

  function updateBump(cart) {
    const bumpEl = document.getElementById("cartBump");
    const bumpChk = document.getElementById("bumpChk");
    if (!bumpEl) return;
    const items = cart.items || [];
    // Find the first eligible Standard pack in the cart
    const eligibleItem = items.find(function(i) { return BUMP_MAP.has(Number(i.variant_id)); });
    if (eligibleItem) {
      const upgradeVariantId = BUMP_MAP.get(Number(eligibleItem.variant_id));
      bumpEl.dataset.upgradeVariant = upgradeVariantId; // store for the change handler
      const alreadyAdded = items.some(function(i) { return Number(i.variant_id) === upgradeVariantId; });
      bumpEl.style.display = "block";
      if (bumpChk) bumpChk.checked = alreadyAdded;
    } else {
      bumpEl.style.display = "none";
      if (bumpChk) bumpChk.checked = false;
    }
  }

  function renderCartDrawer(cart) {
    document.querySelectorAll(".cart-count").forEach((el) => {
      el.textContent = cart.item_count || "";
      el.classList.toggle("show", cart.item_count > 0);
    });
    const itemsEl = document.getElementById("cartItems");
    const footEl = document.getElementById("cartFoot");
    if (!itemsEl) return;
    if (!cart.item_count) {
      itemsEl.innerHTML = `<div class="cart-empty">${I.cart}<p>Your cart is empty.</p><p style="font-size:.85rem;margin-top:8px">Instant digital delivery, your files unlock the moment you check out.</p></div>`;
      if (footEl) footEl.style.display = "none";
      updateBump({ items: [] });
      return;
    }
    if (footEl) footEl.style.display = "block";
    itemsEl.innerHTML = cart.items.map((item) => {
      const img = item.featured_image && item.featured_image.url
        ? `<img src="${item.featured_image.url}&width=128" alt="${item.title}" style="width:64px;height:64px;object-fit:cover;border-radius:3px">`
        : `<div style="width:64px;height:64px;background:var(--surface-3);border-radius:3px"></div>`;
      return `<div class="cart-line"><div>${img}</div><div><div class="cl-name">${item.product_title}</div><div class="cl-meta">${fmtMoney(item.price)} &middot; Digital</div><div class="qty"><button data-qty-key="${item.key}" data-d="-1">&minus;</button><span>${item.quantity}</span><button data-qty-key="${item.key}" data-d="1">+</button></div></div><div><div class="cl-price">${fmtMoney(item.line_price)}</div><button class="cl-remove" data-remove-key="${item.key}">Remove</button></div></div>`;
    }).join("");
    const subEl = document.getElementById("cartSub");
    if (subEl) subEl.textContent = fmtMoney(cart.total_price);
    updateBump(cart);
  }

  function openCart() {
    document.getElementById("cartDrawer")?.classList.add("open");
    document.getElementById("cartOverlay")?.classList.add("open");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    document.getElementById("cartDrawer")?.classList.remove("open");
    document.getElementById("cartOverlay")?.classList.remove("open");
    document.body.style.overflow = "";
  }
  window.openCart = openCart;

  function toast(msg) {
    let wrap = document.getElementById("toastWrap");
    if (!wrap) { wrap = document.createElement("div"); wrap.className = "toast-wrap"; document.body.appendChild(wrap); }
    const t = document.createElement("div");
    t.className = "toast";
    t.innerHTML = `${I.check}<div class="t-txt"><b>${msg}</b></div>`;
    wrap.appendChild(t);
    requestAnimationFrame(() => t.classList.add("show"));
    setTimeout(() => { t.classList.remove("show"); setTimeout(() => t.remove(), 400); }, 2800);
  }
  window.toast = toast;

  document.addEventListener("click", async (e) => {
    const addBtn = e.target.closest("[data-add-variant]");
    if (addBtn) { e.preventDefault(); await addToCart(addBtn.dataset.addVariant, addBtn.dataset.productTitle); return; }
    const qtyBtn = e.target.closest("[data-qty-key]");
    if (qtyBtn) {
      const key = qtyBtn.dataset.qtyKey;
      const d = parseInt(qtyBtn.dataset.d, 10);
      const span = qtyBtn.closest(".qty").querySelector("span");
      const cur = parseInt(span.textContent, 10);
      await cartPost("/cart/change.js", { id: key, quantity: Math.max(0, cur + d) });
      await refreshCart(); return;
    }
    const rmBtn = e.target.closest("[data-remove-key]");
    if (rmBtn) { await cartPost("/cart/change.js", { id: rmBtn.dataset.removeKey, quantity: 0 }); await refreshCart(); return; }
    const previewBtn = e.target.closest("[data-preview]");
    if (previewBtn) { e.preventDefault(); AudioBank.togglePreview(previewBtn.dataset.preview, previewBtn.dataset.audio, previewBtn); return; }
    const faqQ = e.target.closest(".faq-q");
    if (faqQ) { const item = faqQ.closest(".faq-item"); const a = item.querySelector(".faq-a"); const open = item.classList.toggle("open"); a.style.maxHeight = open ? a.scrollHeight + "px" : "0"; return; }
    if (e.target.closest("#openCartBtn")) { openCart(); return; }
    if (e.target.closest("#closeCartBtn")) { closeCart(); return; }
    if (e.target.matches("#cartOverlay")) { closeCart(); return; }
    if (e.target.closest("#openMenuBtn")) { document.getElementById("mobileMenu")?.classList.add("open"); return; }
    if (e.target.closest("#closeMenuBtn")) { document.getElementById("mobileMenu")?.classList.remove("open"); return; }
    const mmLink = e.target.closest(".mobile-menu a");
    if (mmLink) { document.getElementById("mobileMenu")?.classList.remove("open"); return; }
  });

  document.addEventListener("change", async (e) => {
    const chk = e.target.closest("#bumpChk");
    if (!chk) return;
    chk.disabled = true;
    const bumpEl = document.getElementById("cartBump");
    const upgradeVariantId = bumpEl ? Number(bumpEl.dataset.upgradeVariant) : 0;
    if (!upgradeVariantId) { chk.disabled = false; return; }
    try {
      if (chk.checked) {
        const result = await cartPost("/cart/add.js", { items: [{ id: upgradeVariantId, quantity: 1 }] });
        if (result.status) {
          toast("Could not add upgrade - please try again");
          chk.checked = false;
        } else {
          await refreshCart();
        }
      } else {
        const cart = await cartGet();
        const item = (cart.items || []).find(function(i) { return Number(i.variant_id) === upgradeVariantId; });
        if (item) {
          await cartPost("/cart/change.js", { id: item.key, quantity: 0 });
          await refreshCart();
        }
      }
    } catch(err) {
      toast("Could not add upgrade - please try again");
      chk.checked = !chk.checked; // revert
    }
    chk.disabled = false;
  });

  const AudioBank = (function () {
    let current = null;
    const SIM_DUR = 28;
    const PLAY_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M8 5.5v13l11-6.5z"/></svg>';
    const PAUSE_SVG = '<svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><rect x="6.5" y="5.5" width="3.6" height="13" rx="1"/><rect x="13.9" y="5.5" width="3.6" height="13" rx="1"/></svg>';
    const PLAY_SM = '<svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13"><path d="M8 5.5v13l11-6.5z"/></svg>';
    const PAUSE_SM = '<svg viewBox="0 0 24 24" fill="currentColor" width="13" height="13"><rect x="6.5" y="5.5" width="3.6" height="13" rx="1"/><rect x="13.9" y="5.5" width="3.6" height="13" rx="1"/></svg>';

    function stopAll() {
      if (!current) return;
      if (current.audio) { try { current.audio.pause(); } catch (_) {} }
      if (current.raf) cancelAnimationFrame(current.raf);
      if (current.sim) clearInterval(current.sim);
      // PDP legacy player
      if (current.ui) current.ui.classList.remove("playing");
      if (current.btn) current.btn.innerHTML = I.play;
      // Card player
      if (current.card) current.card.classList.remove("is-playing");
      if (current.quickBtn) current.quickBtn.innerHTML = PLAY_SVG;
      if (current.cpBtn) current.cpBtn.innerHTML = PLAY_SM;
      if (current.bars) {
        current.bars.forEach(b => {
          b.classList.remove("played", "active");
          b.style.transform = "scaleY(" + (b.dataset.idleH || "0.18") + ")";
        });
      }
      current = null;
    }

    function fmt(s) { s = Math.max(0, Math.floor(s)); return Math.floor(s / 60) + ":" + String(s % 60).padStart(2, "0"); }

    // PDP viz (legacy bar elements inside .viz)
    function animateViz(el, progress) {
      const bars = el.querySelectorAll(".viz i");
      const active = Math.floor(progress * bars.length);
      bars.forEach((b, i) => { b.classList.toggle("on", i < active); b.style.transform = i === active ? "scaleY(" + (0.6 + Math.random() * 0.9).toFixed(2) + ")" : ""; });
    }

    // Card player bar animation
    function animateBars(bars, progress) {
      if (!bars || !bars.length) return;
      const total = bars.length;
      const playedCount = Math.floor(progress * total);
      bars.forEach(function(b, i) {
        if (i < playedCount) {
          if (!b.dataset.playH) b.dataset.playH = (0.5 + Math.random() * 0.5).toFixed(2);
          b.classList.add("played");
          b.classList.remove("active");
          b.style.transform = "scaleY(" + b.dataset.playH + ")";
        } else if (i === playedCount) {
          b.classList.remove("played");
          b.classList.add("active");
          b.style.transform = "scaleY(" + (0.65 + Math.random() * 0.35).toFixed(2) + ")";
        } else {
          b.classList.remove("played", "active");
          b.style.transform = "scaleY(" + (b.dataset.idleH || "0.18") + ")";
        }
      });
    }

    // PDP legacy start
    function start(id, audioUrl, el) {
      stopAll();
      if (el) el.classList.add("playing");
      const btn = el ? el.querySelector(".pp") : null;
      if (btn) btn.innerHTML = I.pause;
      const timeEl = el ? el.querySelector(".p-time") : null;
      const ctx = { id, ui: el, btn, raf: null, sim: null, audio: null, card: null, quickBtn: null, cpBtn: null, bars: null };
      current = ctx;
      const onEnd = () => stopAll();
      const audio = new Audio(audioUrl || "/cdn/shop/files/" + id + ".mp3");
      ctx.audio = audio;
      audio.addEventListener("ended", onEnd);
      audio.addEventListener("timeupdate", () => {
        if (!audio.duration) return;
        const prog = audio.currentTime / audio.duration;
        if (el) animateViz(el, prog);
        if (timeEl) timeEl.textContent = fmt(audio.currentTime);
      });
      audio.play().catch(() => {
        const t0 = performance.now();
        ctx.sim = setInterval(() => {
          const elapsed = (performance.now() - t0) / 1000;
          const prog = elapsed / SIM_DUR;
          if (prog >= 1) { onEnd(); return; }
          if (el) animateViz(el, prog);
          if (timeEl) timeEl.textContent = fmt(elapsed);
        }, 90);
      });
    }

    // Card player start
    function startCard(id, audioUrl, quickBtn) {
      stopAll();
      const card = quickBtn ? quickBtn.closest(".pcard") : null;
      const cpBtn = card ? card.querySelector(".cp-btn") : null;
      const timeEl = card ? card.querySelector(".cp-time") : null;
      const bars = card ? Array.from(card.querySelectorAll(".cp-viz i")) : [];

      if (card) card.classList.add("is-playing");
      if (quickBtn) quickBtn.innerHTML = PAUSE_SVG;
      if (cpBtn) cpBtn.innerHTML = PAUSE_SM;

      // Seed idle heights as a natural waveform curve
      bars.forEach(function(b, idx) {
        if (!b.dataset.idleH) {
          const t = idx / bars.length;
          const h = (Math.abs(Math.sin(t * Math.PI * 5 + 0.8)) * 0.3 + Math.random() * 0.18 + 0.1).toFixed(2);
          b.dataset.idleH = h;
        }
        b.style.transform = "scaleY(" + b.dataset.idleH + ")";
        b.classList.remove("played", "active");
      });

      const ctx = { id, card, quickBtn, cpBtn, bars, raf: null, sim: null, audio: null, ui: null, btn: null };
      current = ctx;
      const onEnd = () => stopAll();
      const audio = new Audio(audioUrl || "/cdn/shop/files/" + id + ".mp3");
      ctx.audio = audio;
      audio.addEventListener("ended", onEnd);
      audio.addEventListener("timeupdate", () => {
        if (!audio.duration) return;
        const prog = audio.currentTime / audio.duration;
        animateBars(bars, prog);
        if (timeEl) timeEl.textContent = fmt(audio.currentTime);
      });
      audio.play().catch(() => {
        const t0 = performance.now();
        ctx.sim = setInterval(() => {
          const elapsed = (performance.now() - t0) / 1000;
          const prog = elapsed / SIM_DUR;
          if (prog >= 1) { onEnd(); return; }
          animateBars(bars, prog);
          if (timeEl) timeEl.textContent = fmt(elapsed);
        }, 90);
      });
    }

    function toggle(id, audioUrl, el) { if (current && current.id === id) { stopAll(); return; } start(id, audioUrl, el); }

    function togglePreview(id, audioUrl, btn) {
      if (current && current.id === id) { stopAll(); return; }
      // Card context: triggered from .quick-play or .cp-btn inside a .pcard
      if (btn && btn.closest(".pcard")) {
        startCard(id, audioUrl, btn.classList.contains("quick-play") ? btn : btn.closest(".pcard").querySelector(".quick-play"));
        return;
      }
      // Legacy PDP player
      const existing = document.querySelector(".player[data-id=\"" + id + "\"]") || document.getElementById("previewPlayer");
      if (existing && existing.classList.contains("player")) { toggle(id, audioUrl, existing); }
      else { start(id, audioUrl, null); if (btn) btn.innerHTML = I.pause; }
    }

    return { toggle, togglePreview, stopAll };
  })();
  window.AudioBank = AudioBank;

  function initWaveform(canvas, opts) {
    opts = opts || {};
    const ctx = canvas.getContext("2d");
    let w, h, dpr;
    const lines = opts.lines || 3;
    function resize() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = canvas.clientWidth; h = canvas.clientHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();
    window.addEventListener("resize", resize);
    let t = 0, energy = 0.55, energyTarget = 0.55;
    canvas.parentElement?.addEventListener("mousemove", (e) => {
      const r = canvas.getBoundingClientRect();
      energyTarget = 0.4 + (1 - Math.abs((e.clientY - r.top) / r.height - 0.5) * 2) * 0.7;
    });
    canvas.parentElement?.addEventListener("mouseleave", () => (energyTarget = 0.55));
    function draw() {
      ctx.clearRect(0, 0, w, h);
      t += 0.012;
      energy += (energyTarget - energy) * 0.05;
      const barW = 3, step = 10, cols = Math.ceil(w / step);
      for (let i = 0; i < cols; i++) {
        const nx = i / cols;
        const base = Math.sin(nx * 9 + t * 1.6) * Math.cos(nx * 4 - t);
        const amp = 0.5 + 0.5 * Math.sin(nx * 22 + t * 3);
        const mag = Math.abs(base) * amp * energy;
        const bh = 6 + mag * h * 0.42;
        ctx.fillStyle = `rgba(201,168,76,${(0.05 + mag * 0.5).toFixed(3)})`;
        ctx.fillRect(i * step, h / 2 - bh / 2, barW, bh);
      }
      for (let L = 0; L < lines; L++) {
        ctx.beginPath();
        const off = L * 0.7, op = 0.5 - L * 0.13;
        for (let x = 0; x <= w; x += 6) {
          const nx = x / w;
          const yy = h / 2 + Math.sin(nx * 10 + t * 1.8 + off) * 26 * energy * Math.sin(nx * Math.PI) + Math.sin(nx * 26 - t * 2.4 + off) * 10 * energy * Math.sin(nx * Math.PI);
          x === 0 ? ctx.moveTo(x, yy) : ctx.lineTo(x, yy);
        }
        ctx.strokeStyle = `rgba(201,168,76,${op.toFixed(2)})`;
        ctx.lineWidth = L === 0 ? 1.8 : 1;
        ctx.stroke();
      }
      requestAnimationFrame(draw);
    }
    requestAnimationFrame(draw);
  }

  function initReveal() {
    const els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window) || !els.length) { els.forEach((e) => e.classList.add("in")); return; }
    const io = new IntersectionObserver((ents) => { ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } }); }, { threshold: 0.12 });
    els.forEach((e) => io.observe(e));
  }

  function initEmailCapture() {
    document.querySelectorAll("form[data-capture]").forEach((form) => {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        const input = form.querySelector("input[type=email]");
        const ok = input && /^[^\@\s]+@[^\@\s]+\.[^\@\s]+$/.test(input.value.trim());
        if (!ok) { if (input) { input.style.borderColor = "var(--red)"; input.focus(); } return; }
        form.innerHTML = `<div class="capture-ok">${I.check} You're on the list. We'll let you know the second Vol. 2 drops.</div>`;
      });
    });
  }

  function seedCoverWaves() {
    document.querySelectorAll("[id^='waves-'], [id='painWaves']").forEach((el) => {
      const n = 23; let bars = "";
      for (let i = 0; i < n; i++) {
        const t = i / (n - 1);
        const h = 18 + Math.abs(Math.sin(t * Math.PI * 3) * Math.cos(t * 7)) * 78;
        bars += `<i style="height:${h.toFixed(0)}%"></i>`;
      }
      el.innerHTML = bars;
    });
  }

  function boot() {
    cartGet().then(renderCartDrawer).catch(() => {});
    initReveal();
    initEmailCapture();
    seedCoverWaves();
    const heroCanvas = document.getElementById("heroWave");
    if (heroCanvas) initWaveform(heroCanvas, { lines: 3 });
    document.querySelectorAll("canvas.ph-canvas").forEach((c) => initWaveform(c, { lines: 2 }));
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
